import type { FC } from "react";
import React from "react";

import { MediaGallery } from "./MediaGallery.tsx";
import { UploadForm } from "./UploadForm.tsx";

export const MediaUploadDemo: FC = () => (
  <div className="flex flex-col gap-6">
    <UploadForm />
    <MediaGallery />
  </div>
);
